import React from "react";
import config from "../../../config"
import _ from "underscore"


const TrendingItems = React.memo(({trendingSearches}) => {
  return (
    <div className="search-menu__trending-list">
      {_.map(trendingSearches, (trendingItem, idx) => {
        return (
          <TrendingItem key={idx} trendingItem={trendingItem}/>
        )
      })}
    </div>
  )
})

const TrendingItem = React.memo(({trendingItem}) => {
  return (
    <a
        href={`${config.host_rebag_shop}${trendingItem.search_url}`}
        className="search-menu__trending-item"
    >
      {trendingItem.title}
    </a>
  )
})

export default TrendingItems;